import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatIconModule
    ]
})
export class NotificationsComponent implements OnInit {
    notificationsForm: FormGroup;

    constructor(
        private _formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        this.notificationsForm = this._formBuilder.group({
            emailNotifications: [{value: false, disabled: true}],
            pushNotifications: [{value: false, disabled: true}],
            churchEventsNotifications: [{value: false, disabled: true}],
            financialTransactionsNotifications: [{value: false, disabled: true}],
            newMembersNotifications: [{value: false, disabled: true}],
            birthdaysNotifications: [{value: false, disabled: true}],
            calendarEventsNotifications: [{value: false, disabled: true}],
            weeklyDigest: [{value: false, disabled: true}]
        });
    }

    saveNotifications(): void {
        console.log('Salvando configurações de notificações:', this.notificationsForm.value);
        // Aqui será implementada a lógica de salvar as configurações
    }
}
